// Appends a one-shot version marker to a media URL so the browser refetches it
// instead of serving a stale copy.
//
// Needed because /media/ is served with `Cache-Control: max-age=2592000`
// (30 days) while an avatar keeps its filename when it's replaced. Swap a
// player's photo and every browser that already saw the old one keeps showing
// it for up to a month - which reads as "I fixed the photo but the site still
// shows the old one", with no way for the user to tell it's a cache.
//
// This only helps the person who just made the edit (their own list state gets
// the busted URL). The real fix is server-side: version the stored filename, or
// serve /media/ with revalidation instead of a month of blind caching. See
// backend-tasks/2026-09-28-media-cache-and-exif.md.
export const cacheBustUrl = (url, version = Date.now()) => {
    if (!url || typeof url !== "string") return url;
    // Leave data:/blob: URLs alone - they have no cache to bust and a query
    // string would corrupt them.
    if (/^(data|blob):/i.test(url)) return url;
    const [base, hash = ""] = url.split("#");
    const sep = base.includes("?") ? "&" : "?";
    return `${base}${sep}v=${version}${hash ? `#${hash}` : ""}`;
};

export default cacheBustUrl;
